// extracted by mini-css-extract-plugin
export var fadeIn = "_m2-1";
export var modalContent = "_m2-3";
export var overlay = "_m2-0";
export var popoverContent = "_m2-2";
export var results = "_m2-5";
export var searchInputWrapper = "_m2-4";